export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function isInteger (str) {
  return /^-?\d+$/.test(str)
}

export function isDouble (str) {
  return /^(-?\d+)(\.\d+)?$/.test(str)
}

export function isMobile (mobile) {
  return /^1[3-9]\d{9}$/.test(mobile)
}

// 车牌号验证方法
export function isCarNo (carNo) {
  const xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-Z]$)|([A-Z][A-HJ-NP-Z0-9][0-9]{4}$))/
  const creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/

  if (carNo.length === 7) {
    return creg.test(carNo)
  } else if (carNo.length === 8) {
    return xreg.test(carNo)
  } else {
    return false
  }
}
